"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useFormInstance;
var _react = require("react");
var _context = require("../context");
function useFormInstance() {
  var _useContext = (0, _react.useContext)(_context.FormContext),
    form = _useContext.form;
  return form;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/lib/form/hooks/useFormInstance.js
// module id = 2955
// module chunks = 1